import { Router, RouterModule } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { UsuarioService } from "../../common/service/usuario.service";
import { CustomAlertService } from "../../common/service/custom-alert.service";
import { Usuario } from "../../common/model/usuario";
import { environment } from "../../../../environments/environment";
import { WINDOW } from "../../../common/providers/window.provider";
import { Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-esqueci-senha",
  templateUrl: "./esqueci-senha.component.html",
  styleUrls: ["./esqueci-senha.component.scss", "../auth-shared.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    TranslateModule
  ],
  providers: [
    { useClass: CustomAlertService, provide: CustomAlertService },
    { useClass: UsuarioService, provide: UsuarioService }
  ]
})
export class EsqueciSenhaComponent implements OnInit {
  public email: string = "";
  public usuario: Usuario = new Usuario();
  public error: any;
  public isLoading: boolean = false;
  public enviado: boolean = false;

  public AppConfig: any;
  public logo: string = "talkmaestria";

  constructor(
    private usuarioService: UsuarioService,
    private customAlertService: CustomAlertService,
    private router: Router,
    @Inject(WINDOW) private window: Window
  ) {
    if (this.window.location.hostname.includes(".teajudei"))
      this.logo = "teajudei";

    if (this.window.location.hostname.includes(".epbx"))
      this.logo = "talkmaestria";

    if (this.window.location.hostname.includes(".brbots"))
      this.logo = "brbots";
  }

  ngOnInit() {
    this.AppConfig = environment;
  }

  recuperarSenha() {
    this.error = null;

    if (!this.email || this.email.trim() === "") {
      this.error = { email: ["Email é obrigatório"] };
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.email)) {
      this.error = { email: ["Email inválido"] };
      return;
    }

    this.isLoading = true;
    this.usuario = new Usuario();
    this.usuario.login = this.email.trim();

    this.usuarioService.recuperarSenha(this.usuario).subscribe({
      next: () => {
        // Por segurança, exibimos sempre a mesma mensagem de sucesso,
        // independente de o e-mail existir ou não no sistema. Isso evita
        // que seja possível descobrir quais e-mails estão cadastrados
        // (enumeração de usuários).
        this.exibirSucesso();
      },
      error: (error) => {
        // Mesmo em caso de falha na chamada, não revelamos detalhes que
        // permitam inferir a existência do e-mail. Tratamos como sucesso.
        console.error("Erro ao recuperar senha:", error);
        this.exibirSucesso();
      }
    });
  }

  private exibirSucesso() {
    this.isLoading = false;
    this.enviado = true;
    this.customAlertService.show(
      "telaUsuario.recuperacaoSenha",
      "login.sucessoRecuperacao",
      "success"
    );
  }

  voltarLogin() {
    this.router.navigate(["/login"]);
  }
}
